import { createAxiosInstance } from '@/services/axiosService'

export async function getPortalUserUsernameByToken(apiToken, token) {
  try {
    const axiosInstance = createAxiosInstance(apiToken)
    const response = await axiosInstance.get(`/v1/Auth/GetPortalUserUsernameByToken?token=${token}`)
    return response.data
  } catch (error) {
    console.warn('Error getting portal user username by token:', error)
    return null
  }
}
